import React from "react";
import ContentLoader from "react-content-loader";

const LabCreationShimmer = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",  
      paddingTop: "60px", 
      marginLeft: "240px",      
    }}
  >
    <div style={{ width: "90%", maxWidth: "1200px" }}>
      {/* Title */}
      <ContentLoader
        speed={2}
        width="100%"
        height={50}
        backgroundColor="#e0e0e0"
        foregroundColor="#d6d6d6"
      >
        <rect x="0" y="10" rx="4" ry="4" width="200" height="20" />
        <rect x="0" y="35" rx="3" ry="3" width="300" height="12" />
      </ContentLoader>

      {/* Form Fields */}
      <ContentLoader
        speed={2}
        width="100%"
        height={220}
        backgroundColor="#e0e0e0"
        foregroundColor="#d6d6d6"
      >
        {/* Left */}
        <rect x="0" y="10" rx="4" ry="4" width="180" height="15" />
        <rect x="0" y="35" rx="6" ry="6" width="400" height="36" />
        <rect x="0" y="85" rx="4" ry="4" width="180" height="15" />
        <rect x="0" y="110" rx="6" ry="6" width="400" height="36" />
        <rect x="0" y="160" rx="4" ry="4" width="180" height="15" />
        <rect x="0" y="185" rx="6" ry="6" width="400" height="36" />

        {/* Right */}
        <rect x="460" y="10" rx="4" ry="4" width="180" height="15" />
        <rect x="460" y="35" rx="6" ry="6" width="400" height="36" />
        <rect x="460" y="85" rx="4" ry="4" width="180" height="15" />
        <rect x="460" y="110" rx="6" ry="6" width="400" height="36" />
        <rect x="460" y="160" rx="4" ry="4" width="180" height="15" />
        <rect x="460" y="185" rx="6" ry="6" width="400" height="36" />
      </ContentLoader>

      {/* Buttons */}
      <ContentLoader
        speed={2}
        width="100%"
        height={60}
        backgroundColor="#e0e0e0"
        foregroundColor="#d6d6d6"
      >
        <rect x="0" y="10" rx="6" ry="6" width="120" height="40" />
        <rect x="460" y="10" rx="6" ry="6" width="120" height="40" />
      </ContentLoader>

      {/* Table section */}
      <ContentLoader
        speed={2}
        width="100%"
        height={180}
        backgroundColor="#e0e0e0"
        foregroundColor="#d6d6d6"
      >
        {/* Header */}
        <rect x="0" y="10" rx="4" ry="4" width="120" height="16" />
        <rect x="180" y="10" rx="4" ry="4" width="120" height="16" />
        <rect x="360" y="10" rx="4" ry="4" width="120" height="16" />
        <rect x="540" y="10" rx="4" ry="4" width="120" height="16" />

        {/* Rows */}
        {[0, 1, 2].map((row) => (
          <React.Fragment key={row}>
            <rect x="0" y={50 + row * 40} rx="4" ry="4" width="120" height="14" />
            <rect x="180" y={50 + row * 40} rx="4" ry="4" width="120" height="14" />
            <rect x="360" y={50 + row * 40} rx="4" ry="4" width="120" height="14" />
            <rect x="540" y={50 + row * 40} rx="4" ry="4" width="120" height="14" />
          </React.Fragment>
        ))}
      </ContentLoader>
    </div>
  </div>
);

export default LabCreationShimmer;
